module.exports = __webpack_public_path__ + "img/stuart-pro.fb995af7.jpg";